export default __webpack_public_path__ + "static/media/gas-pump.f1b101b0.svg";